// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "5e3fcbca" : chunkId) + "." + {"53":"1853c858734da88e","573":"118e180361b3e82a"}[chunkId] + ".js";
};